// STATE: 12% of the penal amount (all Parishes except Jefferson). $120 minimum.
// Jefferson Parish -12.5% of the penal amount. $120.00 minimum.   

// IMMIGRATION: 20% of the penal amount for a term of 24 months. $100 minimum.    

// Renewal Rate - 10% of the penal amount upon completion of the intitial 24-month term. 
// Immigration bonds wilth full cash collateral will be charged 2% of the penal amount. 

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 120
  if (type === 'STATE') {
    if (additional.county === 'JEFFERSON') {
      value = (bondValue * .125)
    } else {
      value = (bondValue * .12)
    }
    if (value < 120) {
      value = 120
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation